import { types } from 'mobx-state-tree';

export const Registration = types.model('Registration', {
  registrationId: types.identifierNumber,
  firstname: types.string,
  lastname: types.string,
  userName: types.string,
  email: types.string,
  role: types.maybe(types.string),
  organization: types.string,
  category: types.maybe(types.string),
  address: types.string,
  phoneNumber: types.maybe(types.string),
  requestRegistrationMessage: types.string,
  userId: types.maybe(types.integer),
});
